import routes from "./profileRoutes";
import store from "./profileStore";
import links from "./links";

export default {
  install(Vue, options) {
    if (options.router) {
      options.router.addRoute(...routes);
    }

    if (options.store) {
      options.store.registerModule("Profile", store);
    }

    options.store.commit("Dashboard/SET_LINKS", links);
  },
};
